// 公共服务平台页面
const pltfPages = [
    {
        path: "/expertInfo",
        name: "ExpertInfo",
        component: () => import("@/views/pltf/ExpertInfo"),
        meta: { menuName: "服务专家信息" }
    },
    {
        path: "/itemRequirement",
        name: "ItemRequirement",
        component: () => import("@/views/pltf/ItemRequirement"),
        meta: { menuName: "服务需求管理" }
    },
    {
        path: "/itemApplyEnt",
        name: "ItemApplyEnt",
        component: () => import("@/views/pltf/ItemApplyEnt"),
        meta: { menuName: "服务申请管理" }
    },
    {
        path: "/requirementRespEnt",
        name: "ItemResponseEnt",
        component: () => import("@/views/pltf/ItemResponseEnt"),
        meta: { menuName: "需求响应管理" }
    },
    {
        path: "/creditOnlineManageEnt",
        name: "CreditOnlineManageEnt",
        component: () => import("@/views/pltf/CreditOnlineManageEnt"),
        meta: { menuName: "服务过程评价" }
    },
    {
        path: "/entServiceComplete",
        name: "EntServiceComplete",
        component: () => import("@/views/pltf/EntServiceComplete"),
        meta: { menuName: "服务结果确认" }
    },
    {
        path: "/orgItemManage",
        name: "OrgItemManage",
        component: () => import("@/views/pltf/OrgItemManage"),
        meta: { menuName: "服务项目管理" }
    },
    {
        path: "/itemApplyOrg",
        name: "ItemApplyOrg",
        component: () => import("@/views/pltf/ItemApplyOrg"),
        meta: { menuName: "服务申请受理" }
    },
    {
        path: "/itemResponseOrg",
        name: "ItemResponseOrg",
        component: () => import("@/views/pltf/ItemResponseOrg"),
        meta: { menuName: "服务响应处理" }
    },
    {
        path: "/creditOnlineManageOrg",
        name: "CreditOnlineManageOrg",
        component: () => import("@/views/pltf/CreditOnlineManageOrg"),
        meta: { menuName: "服务过程及评价管理" }
    },
    {
        path: "/orgServiceComplete",
        name: "OrgServiceComplete",
        component: () => import("@/views/pltf/OrgServiceComplete"),
        meta: { menuName: "服务结果确认" }
    },
    {
        path: "/creditOfflineManage",
        name: "CreditOfflineManage",
        component: () => import("@/views/pltf/CreditOfflineManage"),
        meta: { menuName: "服务过程及评价记录" }
    },
    {
        path: "/orgServiceRecord",
        name: "OrgServiceRecord",
        component: () => import("@/views/pltf/OrgServiceRecord"),
        meta: { menuName: "工作服务记录" }
    },
    {
        path: "/activityHistoryManage",
        name: "ActivityHistoryManage",
        component: () => import("@/views/pltf/ActivityHistoryManage"),
        meta: { menuName: "历史活动管理" }
    },
    {
        path: "/successCase",
        name: "SuccessCase",
        component: () => import("@/views/pltf/SuccessCase"),
        meta: { menuName: "成功案例管理" }
    },
    {
        path: "/myConsultation",
        name: "ConsultationManage",
        component: () => import("@/views/pltf/ConsultationManage"),
        meta: { menuName: "我的问题咨询" }
    },
    {
        path: "/consultationAnswer",
        name: "ConsultationAnswer",
        component: () => import("@/views/pltf/ConsultationAnswer"),
        meta: { menuName: "问题咨询解答" }
    },
    {
        path: "/complaintEnt",
        name: "ComplaintEnt",
        component: () => import("@/views/pltf/ComplaintEnt"),
        meta: { menuName: "我的投诉举报" }
    },
    {
        path: "/complaintOrg",
        name: "ComplaintOrg",
        component: () => import("@/views/pltf/ComplaintOrg"),
        meta: { menuName: "投诉举报处理" }
    },
    {
        path: "/auditOrgItem",
        name: "AuditOrgItem",
        component: () => import("@/views/pltf/AuditOrgItem"),
        meta: { menuName: "服务项目监管" }
    },
    {
        path: "/auditCredit",
        name: "AuditCredit",
        component: () => import("@/views/pltf/AuditCredit"),
        meta: { menuName: "服务过程及评价监管" }
    },
    {
        path: "/auditActivityHistory",
        name: "AuditActivityHistory",
        component: () => import("@/views/pltf/AuditActivityHistory"),
        meta: { menuName: "历史服务活动" }
    },
    {
        path: "/auditOrgServiceRecord",
        name: "AuditOrgServiceRecord",
        component: () => import("@/views/pltf/AuditOrgServiceRecord"),
        meta: { menuName: "服务记录监管" }
    },
    {
        path: "/auditItemRequirement",
        name: "AuditItemRequirement",
        component: () => import("@/views/pltf/AuditItemRequirement"),
        meta: { menuName: "服务需求监管" }
    },
    {
        path: "/auditSuccessCase",
        name: "AuditSuccessCase",
        component: () => import("@/views/pltf/AuditSuccessCase"),
        meta: { menuName: "成功案例监管" }
    },
    {
        path: "/auditComplaint",
        name: "AuditComplaint",
        component: () => import("@/views/pltf/AuditComplaint"),
        meta: { menuName: "平台投诉举报监管" }
    },
    {
        path: "/auditConsultation",
        name: "AuditConsultation",
        component: () => import("@/views/pltf/AuditConsultation"),
        meta: { menuName: "平台问题咨询监管" }
    },
    {
        path: "/auditAppeal",
        name: "AuditAppeal",
        component: () => import("@/views/pltf/AuditAppeal"),
        meta: { menuName: "门户互动诉求咨询" }
    },
];

export default pltfPages;